import background from './background.mjs'
import {
  imgproxySettings,
  mobileImgproxySettings,
  resolvePaceOptionsFromSKU as resolveOptionsFromSKU,
  getSKUWithoutPrefix,
  stripMatteOrInfinitePrefix,
} from './shared.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    black: {
      pathTemplate: 'gs://sg360/240514/gts-corrections/gtf_Iblack-{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/240514/gtf_Iclear-{nnn}.png',
    },
    grey: {
      pathTemplate: 'gs://sg360/240509/gtf_Igrey-{nnn}.png',
    },
    slateblue: {
      pathTemplate: 'gs://sg360/240509/gtf_Islateblue-{nnn}.png',
    },
    white: {
      pathTemplate: 'gs://sg360/240514/gts-corrections/gtf_Rwhite-{nnn}.png',
    },
    desertsand: {
      pathTemplate: 'gs://sg360/260311/gtf_Idesertsand--{nnn}.png',
    },
  },
}

export const earsocks = {
  id: 'earsocks',
  name: 'Earsocks',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Rblack: {
      pathTemplate: 'gs://sg360/240514/gts-corrections/ges_Rblack-{nnn}.png',
    },
    Rgrey: {
      pathTemplate: 'gs://sg360/240509/ges_Rgrey-{nnn}.png',
    },
    Rpink: {
      pathTemplate: 'gs://sg360/240509/ges_Rpink-{nnn}.png',
    },
    Rslateblue: {
      pathTemplate: 'gs://sg360/240509/ges_Rslateblue-{nnn}.png',
    },
    Rwhite: {
      pathTemplate: 'gs://sg360/240514/gts-corrections/ges_Rwhite-{nnn}.png',
    },
    Rdesertsand: {
      pathTemplate: 'gs://sg360/260311/ges_Rdesertsand--{nnn}.png',
    },
    Rstone: {
      pathTemplate: 'gs://sg360/240509/ges_Rstone_{nnn}.png',
    },
  },
}

export const icons = {
  id: 'icons',
  name: 'Icons',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Bblack: {
      pathTemplate: 'gs://sg360/240509/gti_Bblack-{nnn}.png',
    },
    Bblue: {
      pathTemplate: 'gs://sg360/240509/gti_Bblue-{nnn}.png',
    },
    Bgold: {
      pathTemplate: 'gs://sg360/240509/gti_Bgold-{nnn}.png',
    },
    Bgunmetal: {
      pathTemplate: 'gs://sg360/240509/gti_Bgunmetal-{nnn}.png',
    },
    Bpurple: {
      pathTemplate: 'gs://sg360/240509/gti_Bpurple-{nnn}.png',
    },
    Bred: {
      pathTemplate: 'gs://sg360/240509/gti_Bred-{nnn}.png',
    },
    Brosegold: {
      pathTemplate: 'gs://sg360/240509/gti_Brosegold-{nnn}.png',
    },
    Bsilver: {
      pathTemplate: 'gs://sg360/240509/gti_Bsilver-{nnn}.png',
    },
    Bwhite: {
      pathTemplate: 'gs://sg360/240509/gti_Bwhite-{nnn}.png',
    },
  },
}

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    clear: {
      pathTemplate: 'gs://sg360/260416/gts/gtle_8clear_{nnn}.png',
    },
    gold: {
      pathTemplate: 'gs://sg360/260416/gts/gtle_8gold_{nnn}.png',
    },
    chromecatfour: {
      pathTemplate: 'gs://sg360/260416/gts/gtle_8chrome4_{nnn}.png',
    },
    hvblue: {
      pathTemplate: 'gs://sg360/260416/gts/gtle_8hvblue_{nnn}.png',
    },
    pink: {
      pathTemplate: 'gs://sg360/260416/gts/gtle_8rose_{nnn}.png',
    },
    silverblue: {
      pathTemplate: 'gs://sg360/260416/gts/gtle_8silverblue_{nnn}.png',
    },
    smoke: {
      pathTemplate: 'gs://sg360/260416/gts/gtle_8smoke_{nnn}.png',
    },
    IRhvblue: {
      pathTemplate: 'gs://sg360/260416/gts/gtle_8IRIShvblue_{nnn}.png',
    },
    IRsmoke: {
      pathTemplate: 'gs://sg360/260416/gts/gtle_8IRISsmoke_{nnn}.png',
    },
    chrome4: {
      pathTemplate: 'gs://sg360/260416/gts/gtle_8chrome4_{nnn}.png',
    },
  },
}

export const iris = {
  id: 'iris',
  name: 'Iris Mask',
  imgproxySettings,
  mobileImgproxySettings,
  isIrisMask: true,
  options: {
    none: {
      disabled: true,
    },
    IRsmoke: {
      pathTemplate: 'gs://sg360/260416/gts/gtle_8IRISsmoke_overlay_{nnn}.png',
      maxOpacity: 0.8,
    },
    IRhvblue: {
      pathTemplate: 'gs://sg360/260416/gts/gtle_8IRIShvblue_overlay_{nnn}.png',
      maxOpacity: 0.8,
    },
  },
}

function resolveOptions(customisedProduct) {
  const options = {
    frame: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.frameChoice?.sku)),
    icons: getSKUWithoutPrefix(customisedProduct.iconChoice.sku),
    earsocks: getSKUWithoutPrefix(customisedProduct.earsocksChoice.sku),
    lens: getSKUWithoutPrefix(customisedProduct.lensChoice?.skuWithoutLensTech),
    iris: getSKUWithoutPrefix(customisedProduct.lensChoice?.skuWithoutLensTech),
  }

  return options
}

function resolveSecondaryOptions() {
  return {}
}

export default {
  supports360: false,
  layers: [background, frame, earsocks, icons, lenses, iris],
  resolveOptions,
  resolveSecondaryOptions,
  resolveOptionsFromSKU,
}
